module.exports = __webpack_public_path__ + "assets/img/[PDC]-Ebook-Papier-Dommages-Collateraux.cf7f617c.jpg";